import { Admin, BuilderAddress, BuilderMapping } from '@app/base/core/models';
import { BuilderMappingOne } from './builder.mapping.model';

export class BuilderInfo {
  Admin: boolean;
  BuilderId: string[];
  CompanyName: string;
  IsActive: string;
  CompanyAddress: BuilderAddress;
  CompanyEmail: string;
  BuilderMapping: BuilderMapping[];
  subsidiaryList: any[];
  subsidiaryId: string[];
}

export class BuilderInfoOne {
    reEnterEmail: null;
    id: string;
    IsActive: string;
    status: string;
    _companyName: string;
    companyName: string;
    builderTypeCode: string;
    email: string;
    recCreateDate: string;
    recCreateUserId: string;
    recUpdateUserId: string;
    recUpdateDate: string;
    builderAddresses: BuilderAddress;
    builderUsers: Admin;
  builderMapping: BuilderMappingOne[];
}
